import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EveCall } from 'src/app/models/eve-call';
import { ConferenceService } from 'src/app/services/conference.service';
import { SipService } from 'src/app/services/sip.service';


@Component({
  selector: 'app-make-call',
  templateUrl: './make-call.component.html',
  styleUrls: ['./make-call.component.css'],
})
export class MakeCallComponent implements OnInit {
  /**
   *
   */
  constructor(
    private sipService: SipService, 
    private conferenceService: ConferenceService, 
    private snack: MatSnackBar) { 
  }

  @Input() remoteDisplayName!: string;
  @Input() targetNumber!: string;
  @Input() disabled = false;
  @Output() postMakeCall : EventEmitter<void>  = new EventEmitter<void>();
  ngOnInit() {}
  async makeCall() {
    try {
      if (!this.targetNumber) {
        console.error('Cannot make call due to errors or empty number');
        throw new Error('Invalid call parameters');
      }

      await this.holdAllUnHeldCalls(); // Hold all other unheld calls

      // find active conference and deactivate it
      const activeConference = this.conferenceService.getActiveConference();
      if (activeConference) {
        await this.conferenceService.deactivateCurrentConference();
      }

      // Initiate outgoing call via SIP service (it will add the call to the active calls list)
      const newCall = await this.sipService.makeCall(this.remoteDisplayName, this.targetNumber);
      // Clear dialpad input after initiating the call
      if (this.postMakeCall) this.postMakeCall.emit();
    } catch (error: any) {
      // this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Message Content', life: 3000 });
      const errorMessage = 'Failed to make call: ' + error.message;
      this.snack.open(errorMessage, 'Dismiss');
    }
  }

   private getAllUnHoldCalls(): EveCall[] | null {
      const activeCalls = this.sipService.getActiveCalls();
      if (!activeCalls || activeCalls.length === 0) return null;
      return activeCalls.filter(
        (c) => c.isOnHold === false && c.isInConference === false
      );
    }
    
  private async holdAllUnHeldCalls(): Promise<void[]> {
    const unheldCalls = this.getAllUnHoldCalls();
    if (!unheldCalls || unheldCalls.length === 0) return Promise.resolve([]);
    return await Promise.all(unheldCalls.map((c) => c.holdCall()));
  }
}
